module.exports = __webpack_public_path__ + "img/nurse.be5030ca.webp";